import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateLoader, TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpJsonUtilities } from './http/http-json-utilities.service';
import { ActivityService } from './activity/activity.service';
import { HttpConfigService } from './http/http-config.service';
import { AuthInterceptor } from './services/auth.interceptor';

import {
  AccountClient,
  API_BASE_URL,
  ClientClient,
  DashboardClient,
  ParkerClient,
  ParkerCompanyClient,
  ThirdPartyUserClientZoneAssignmentClient,
  UserAccountClient,
  UserControlPlateClient,
  ZoneClient,
  ZoneDeviceClient,
} from './models/models.swagger.generated';

import { AppErrorMessagesService } from './services/app-error-messages.service';
import { EnumTranslationService } from './services/enum-translation.service';

import { environment } from '../../environments/environment';
import { LoginProxy } from './http/login-proxy.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import {
  ColumnChooserService,
  CommandColumnService,
  EditService,
  FilterService,
  PageService, ResizeService,
  SearchService,
  SortService,
  ToolbarService,
} from '@syncfusion/ej2-angular-grids';
import { ClientService } from './services/client/client.service';
import { LightboxModule } from 'ngx-lightbox';
import { TranslationLoaderResolver } from './resolver/translation-loader.resolver';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ModalHelperService } from './shared/modal-helper';
import { EnumFilterService } from './services/enum-filter.service';

// AoT requires an exported function for factories
export const HttpLoaderFactory = (httpClient: HttpClient) => new TranslateHttpLoader(httpClient, '../../assets/i18n/', '.json');

export const tokenGetter = () =>  localStorage.getItem(environment.localStorageToken);

@NgModule({ bootstrap: [],
    exports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        ReactiveFormsModule,
        TranslateModule,
        //BrowserAnimationsModule, // WARNING: do not use browser animations module here, it will cause errors with syncfusion V25+
        FontAwesomeModule,
        NgIdleKeepaliveModule,
    ], imports: [CommonModule,
        RouterModule,
        ReactiveFormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        //BrowserAnimationsModule, // WARNING: do not use browser animations module here, it will cause errors with syncfusion V25+
        FontAwesomeModule,
        FormsModule,
        NgIdleKeepaliveModule.forRoot(),
        LightboxModule,
        ZXingScannerModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: API_BASE_URL, useValue: environment.apiServerUrl },
        HttpClient,
        HttpJsonUtilities,
        HttpConfigService,
        TranslateService,
        TranslatePipe,
        ActivityService,
        LoginProxy,
        AppErrorMessagesService,
        EnumTranslationService,
        ModalHelperService,
        ClientService,
        TranslationLoaderResolver,
        EnumFilterService,
        /* swagger clients */
        AccountClient,
        ClientClient,
        DashboardClient,
        ParkerClient,
        ParkerCompanyClient,
        UserControlPlateClient,
        UserAccountClient,
        ZoneClient,
        ZoneDeviceClient,
        ThirdPartyUserClientZoneAssignmentClient,
        /* Syncfusion services */
        PageService,
        ToolbarService,
        ColumnChooserService,
        FilterService,
        SortService,
        EditService,
        CommandColumnService,
        SearchService,
        ResizeService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class BaseModule {
}
